import { render, staticRenderFns } from "./AboutAppPage.vue?vue&type=template&id=050e6326&scoped=true"
import script from "./AboutAppPage.vue?vue&type=script&lang=js"
export * from "./AboutAppPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050e6326",
  null
  
)

export default component.exports